import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { InstantErrorMatcher } from '../../instant-error-matcher';

@Component({
  standalone: false,
  selector: 'mtn-text-area-field',
  templateUrl: './text-area-field.component.html',
  styleUrls: ['./text-area-field.component.scss']
})
export class TextAreaFieldComponent  {

  @Input()
  form: UntypedFormGroup;
  @Input()
  controlName: string;
  @Input()
  maxLength: number = 255;
  @Input()
  placeholder: string;

  instantErrorMatcher: ErrorStateMatcher = new InstantErrorMatcher();

  constructor() {
  }


}
